export const narrowScreenWidth = 1080;
